module.exports = __webpack_public_path__ + "img/sand.fe8cde28.jpg";